import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=6182b092&scoped=true&"
import script from "./ProductRow.vue?vue&type=script&lang=ts&"
export * from "./ProductRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=6182b092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6182b092",
  null
  
)

export default component.exports